import React from 'react'

const PageNoData = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '300px' }}>
    <img 
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8x0dBHazn5dkcBb5QJqdC-dI7wQFZs2V1Aw&s" 
      className='img-fluid mb-3' 
      style={{ maxWidth: '100%', height: 'auto' }} 
      alt="No Data"
    />
    <h5 className="steelblue text-center">No records have been added yet.</h5>
  </div>
  )
}

export default PageNoData
